export const text = {
  OnboardingTask: "Onboarding Task",
  OnboardingQuiz: "Onboarding Quiz",
  OnboardingTemplate: "Onboarding Template",
  AddOnboardingTask: "Add Onboarding Task",
  AddOnboardingQuiz: "Add Onboarding Quiz",
  AddOnboardingTemplate: "Add Onboarding Template",
  TaskType: "Task Type",
  Attachment: "Attachment",
  SubTitle: "Sub Title",
  TotalDays: "Total Days",
  Onboardingquizaddedsuccessfully: "Onboarding quiz added successfully!",
  Onboardingquizupdatedsuccessfully: "Onboarding quiz updated successfully!",
  OnboardingquizDeletedsuccessfully: "Onboarding quiz deleted successfully!",
  Onboardingtaskaddedsuccessfully: "Onboarding task added successfully!",
  Anattachmentisrequired: "An attachment is required",
  OnboardingTaskDeletedsuccessfully: "Onboarding task deleted successfully!",
  Onboardingtaskupdatedsuccessfully: "Onboarding task updated successfully!",
  OnboardingtemplateDeletedsuccessfully:
    "Onboarding template Deleted successfully!",
  Onboardingtemplateupdatedsuccessfully:
    "Onboarding template updated successfully!",
  Onboardingtemplatecancelledsuccessfully:
    "Onboarding template cancelled successfully!",
  Onboardingtemplatesubmittedsuccessfully:
    " Onboarding template submitted successfully!",
  Onboardingtemplateaddedsuccessfully:
    "Onboarding template added successfully!",
  PleaseaddtasktoyourOnboardingTemplate:
    "Please add task to your Onboarding Template.",
  formatsareallowed: "formats are allowed.",
  Only: "Only",
  Onboarding: "Onboarding",
  PleaseaddQuestiontoyourQuiz: "Please add Question to your Quiz.",
};
